export const isBrowser = () => typeof window !== 'undefined';
export const TITLE_APP = 'Spendenportal | Wilderness International';

export const URL_PATHNAME = {
  DONOR_PORTAL: '/donor-portal',
  DONATION_MANAGEMENT: 'donation-management',
};

export const Regex_Emoji = /[^\p{L}0-9\s@!#$%^&*()_+{}\[\]:;<>,.?~\/\\`|"'-]/gu;

enum ResponseStatusType {
  OK = 'OK',
  BAD_REQUEST = 'BAD_REQUEST',
  UNAUTHORIZED = 'UNAUTHORIZED',
  VALIDATION_EXCEPTION = 'VALIDATION_EXCEPTION',
  EXCEPTION = 'EXCEPTION',
  WRONG_CREDENTIALS = 'WRONG_CREDENTIALS',
  ACCESS_DENIED = 'ACCESS_DENIED',
  NOT_FOUND = 'NOT_FOUND',
  DUPLICATE_ENTITY = 'DUPLICATE_ENTITY',
  INFO_USER_NOT_MATCH = 'INFO_USER_NOT_MATCH',
  EXPRIED_HAS_OTP = 'EXPRIED_HAS_OTP',
}

export default ResponseStatusType;

export const EmailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export enum LanguageCode {
  EN = 'EN',
  DE = 'DE',
  ES = 'ES',
}
export const LanguageList = [
  { name: LanguageCode.EN, code: LanguageCode.EN },
  { name: LanguageCode.DE, code: LanguageCode.DE },
];

export const isBrowserLocal = () => typeof localStorage !== 'undefined';

export const getLanguageDefault = () => {
  if (isBrowserLocal()) {
    const getLanguage = localStorage.getItem('language_code') || 'de';
    return LanguageList.find(lan => lan.code === getLanguage.toUpperCase()) || LanguageList[0];
  }
  return LanguageList[0];
};
export const FooterLink = {
  Logo: {
    DE: 'https://www.transparency.de/mitmachen/initiative-transparente-zivilgesellschaft',
    EN: 'https://www.transparency.de/mitmachen/initiative-transparente-zivilgesellschaft',
  },
  Contact: {
    DE: 'https://www.wilderness-international.org/kontakt',
    EN: 'https://www.wilderness-international.org/en/contact',
  },
  Imprint: {
    DE: 'https://www.wilderness-international.org/impressum',
    EN: 'https://www.wilderness-international.org/en/imprint',
  },
  Privacy: {
    DE: 'https://www.wilderness-international.org/datenschutz',
    EN: 'https://www.wilderness-international.org/en/privacy',
  },
  About: {
    DE: 'https://www.wilderness-international.org/die-stiftung',
    EN: 'https://www.wilderness-international.org/en/the-foundation',
  },
  Transparency: {
    DE: 'https://www.wilderness-international.org/transparenz',
    EN: 'https://www.wilderness-international.org/en/transparency',
  },
  CO2: {
    DE: 'https://www.wilderness-international.org/co2-kompensation',
    EN: 'https://www.wilderness-international.org/en/co2-compensation',
  },
  Forest: {
    DE: 'https://www.wilderness-international.org/urwaldschutz-peru',
    EN: 'https://www.wilderness-international.org/en/rainforest-protection-peru',
  },
  FAQ: {
    DE: 'https://www.wilderness-international.org/faq',
    EN: 'https://www.wilderness-international.org/en/faqs',
  },
  HOME: {
    DE: 'https://www.wilderness-international.org',
    EN: 'https://en.wilderness-international.org',
  },
};

export const FooterLinkV2 = {
  Imprint: {
    DE: 'https://wilderness-international.org/impressum',
    EN: 'https://en.wilderness-international.org/impressum',
  },
  Privacy: {
    DE: 'https://wilderness-international.org/datenschutz',
    EN: 'https://en.wilderness-international.org/datenschutz',
  },
  AGB: {
    DE: 'https://wilderness-international.org/allgemeine-spendenbedingungen',
    EN: 'https://en.wilderness-international.org/allgemeine-spendenbedingungen',
  },
};

export const LocaleLanguage = {
  DE: 'de-DE',
  EN: 'en-US',
};

export const LocaleLanguagePayPal = {
  DE: 'en_DE',
  EN: 'en_US',
};

export const SLIDER_STR = 'converter_old_slider_value';

export const INDEX_OPTION = {
  STEP_INFO: 2,
  STEP_DIS: 1,
  STEP_THANKS: 0,
};

export const RECURRING_OPTION = {
  ONE: '0',
  MONTHLY: '1',
  YEARLY: '12',
};

export const SEO_META = {
  title: {
    de: 'Deine Spende für den Regenwald | Wilderness International',
    en: 'Your donation for the rainforest | Wilderness International',
  },
  description: {
    de: 'Mit deiner Spende schützt du mit je 1€ zum einen 1qm natürlichen Lebensraum als Wildnis-Pate und kompensierst zum anderen 60 kg CO2, die dort als Biomasse gebunden sind.',
    en: 'With your 1€ donation you protect 1sqm of natural habitat as a wilderness sponsor and you compensate 60 kg of CO2, which are bound there as biomass.',
  },
  author: {
    de: 'Stiftung Wilderness International',
    en: 'Foundation Wilderness International',
  },
  image: 'https://media.wilderness-international.org/uploads/default_seo.jpg',
};

export const Status_Land = {
  Active: 'active',
  Deleted: 'deleted',
  Paused: 'paused',
  Completed: 'completed',
  New: 'new',
  Used: 'used',
  Public: 'public',
};

export const LANGUAGE_OPTIONS = [
  {
    name: {
      de: 'Deutsch',
      en: 'German',
    },
    code: 'de',
  },
  {
    name: {
      de: 'Englisch',
      en: 'English',
    },
    code: 'en',
  },
];

export const DONATION_TYPES = {
  CODE: 'code',
  LAND: 'land',
  CAMPAIGN: 'campaign',
};

export const RECEIPT_TYPES = {
  PARTNER: 'partner',
  REDEEMER: 'redeemer',
  NONE: 'none',
};

export const RHYTHM_LIST = [
  {
    code: 0,
    name: {
      en: 'once',
      de: 'einmalig',
    },
  },
  {
    code: 1,
    name: {
      en: 'monthly',
      de: 'monatlich',
    },
  },
  {
    code: 3,
    name: {
      en: 'quarterly',
      de: 'vierjährlich',
    },
  },
  {
    code: 6,
    name: {
      en: 'biannually',
      de: 'halbjährlich',
    },
  },
  {
    code: 12,
    name: {
      en: 'annually',
      de: 'jährlich',
    },
  },
];

export const PAYMENT_METHOD = [
  {
    code: 'Kreditkarte',
    name: {
      en: 'Card',
      de: 'Kreditkarte',
    },
  },
  {
    code: 'sepa lastschrift',
    name: {
      en: 'SEPA Direct Debit',
      de: 'SEPA Lastschrift',
    },
  },
  {
    code: 'us_bank_account',
    name: {
      en: 'US Bank Account',
      de: 'US Bankkonto',
    },
  },
];

export const TAB_HEADER_LIST = [
  {
    code: '0',
    name: {
      en: 'Donation',
      de: 'Spende',
    },
  },
  {
    code: '1',
    name: {
      en: 'Certificate',
      de: 'Urkunde',
    },
  },
  {
    code: '2',
    name: {
      en: 'Donation Receipt',
      de: 'Quittung',
    },
  },
  {
    code: '3',
    name: {
      en: 'Payment',
      de: 'Zahlung',
    },
  },
];

export const DEFAULT_ACTIVE_TAB_INDEX = 0;
